'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

require('./style.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PaymentListView: {
        displayName: 'PaymentListView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Order/PaymentList/default/PaymentListView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

// import AdditionalFields from 'components/Order/PaymentList/AdditionalFields';

var PaymentListView = _wrapComponent('PaymentListView')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(PaymentListView, _Component);

    function PaymentListView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PaymentListView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PaymentListView.__proto__ || (0, _getPrototypeOf2.default)(PaymentListView)).call.apply(_ref, [this].concat(args))), _this), _this.showImg = function (icon) {
            if (icon) {
                return _react3.default.createElement('img', { src: icon });
            }
        }, _this.renderPayments = function (payments, onChange) {
            var title = void 0;
            var newPayments = payments.map(function (paymentItem) {
                title = paymentItem.lang_data_rus;
                if (_this.props.currency.code === 'GBP' || _this.props.currency.code === 'USD' || _this.props.currency.code === 'EUR' || _this.props.currency.code === 'TRY' || _this.props.currency.code === 'AED') {
                    title = paymentItem.lang_data_eng;
                }
                return _react3.default.createElement(
                    'li',
                    { key: paymentItem.slug },
                    _react3.default.createElement(
                        'label',
                        null,
                        _react3.default.createElement('img', { src: paymentItem.icon }),
                        ' ',
                        title,
                        _react3.default.createElement('input', { onChange: onChange, id: paymentItem.id, type: 'radio', value: paymentItem.slug, name: 'payment_methods', 'data-text': title, 'data-img': paymentItem.icon })
                    )
                );
            });
            return newPayments;
        }, _this.showSelect = function (event) {
            event.preventDefault();
            var element = document.getElementsByClassName('select_input_wrap');
            element = element[0];
            var className = 'active';

            if (!element || !className) {
                return;
            }

            var classString = element.className;

            if (classString == 'select_input_wrap') {
                classString += ' ' + className;
            } else {
                classString = 'select_input_wrap';
            }

            element.className = classString;

            return;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(PaymentListView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                onChange = _props.onChange,
                payments = _props.payments,
                onChangeAdditionalField = _props.onChangeAdditionalField,
                onShowAdditionalField = _props.onShowAdditionalField,
                additionalFieldText = _props.additionalFieldText,
                slug = _props.slug,
                slugText = _props.slugText,
                slugImg = _props.slugImg,
                warning = _props.warning,
                lang = _props.lang;


            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'div',
                    { className: 'pay_method row' },
                    title ? _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-lg-5' },
                        _react3.default.createElement(
                            'div',
                            { className: 'pay_method_label' },
                            _react3.default.createElement(
                                'label',
                                { className: '' },
                                title
                            )
                        )
                    ) : null,
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-lg-7 ' + (warning ? 'pay_method_warning' : '') },
                        _react3.default.createElement(
                            'div',
                            { className: 'select_input_wrap' },
                            _react3.default.createElement(
                                'div',
                                { className: 'select_input_wrap__inside' },
                                _react3.default.createElement(
                                    'label',
                                    { className: 'main_field', onClick: this.showSelect },
                                    this.showImg(slugImg),
                                    slugText,
                                    _react3.default.createElement('input', { type: 'text', placeholder: lang['store.payment_list.select_payment_method'], defaultValue: slug })
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'select_dropdown' },
                                    _react3.default.createElement(
                                        'ul',
                                        null,
                                        this.renderPayments(payments, onChange)
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return PaymentListView;
}(_react2.Component), _class.propTypes = {
    title: _react2.PropTypes.string,
    onChange: _react2.PropTypes.func,
    onChangeAdditionalField: _react2.PropTypes.func,
    onShowAdditionalField: _react2.PropTypes.func,
    payments: _react2.PropTypes.array,
    slug: _react2.PropTypes.string,
    additionalFieldText: _react2.PropTypes.string,
    refAdditionalField: _react2.PropTypes.func,
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object.isRequired
}, _class.defaultProps = {
    onChange: function onChange() {},
    onChangeAdditionalField: function onChangeAdditionalField() {},
    onShowAdditionalField: function onShowAdditionalField() {},
    refAdditionalField: function refAdditionalField() {},
    payments: [],
    additionalFieldText: ''
}, _temp2));

exports.default = PaymentListView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/PaymentList/default/PaymentListView.jsx
// module id = 1706
// module chunks = 0